import { Chip, ChipProps, Tab, Tabs } from '@mui/material';

export interface TableTabProps {
    value: any;
    label: string;
    color: ChipProps['color'];
    count: number;
}

const TableTab: React.FC<TableTabProps> = ({
    selectedValue,
    value,
    label,
    color,
    count,
    ...props
}) => {
    return (
        <Tab
            value={value}
            label={label}
            icon={
                <Chip
                    variant={selectedValue === value ? 'filled' : 'tonal'}
                    color={color}
                    label={count}
                    sx={{ p: 0, height: 24 }}
                />
            }
            {...props}
            iconPosition="end"
            sx={{ minHeight: 'unset' }}
        />
    );
};

const TableTabs = ({ value, onChange, tabs = [] }) => {
    return (
        <Tabs value={value} onChange={onChange}>
            {tabs.map(tab => (
                <TableTab key={tab.value} selectedValue={value} {...tab} />
            ))}
        </Tabs>
    );
};

export default TableTabs;
